export default "__VITE_ASSET__ZMp30VaP__"